<template>
  <div class="blank-layout">
    <div class="main-content">
      <slot />
      <page-footer />
    </div>
  </div>
</template>

<script>
import PageFooter from "../components/PageFooter.vue";
export default {
  components: { PageFooter },
};
</script>

<style lang="scss" scoped>
</style>